export * from './login';
export * from './oauth';
export * from './lang';

// 使用该登录系统的平台（URL 必须包含此参数）
export const Platform = {
    H5: 1,
    Iframe: 2,
    WebView: 3, // GHome 的 ios webview 平台
    Android: 4,
    H5Transfer: 5, // Tencent LI 账号迁移的 h5 平台
    WebViewTransfer: 6, // Tencent LI 账号迁移的 webview 平台（平移了 H5 的功能，但样式上做到 100% 自适应）
    1: 'h5',
    2: 'iframe',
    3: 'webview',
    4: 'android',
    5: 'h5Transfer',
    6: 'webviewTransfer',
};

// 龙之谷 地区码
export const RegionId = {
    tw: 1,
    ko: 2,
    ja: 3,
    global: 9,
    1: 'tw',
    2: 'ko',
    3: 'ja',
    9: 'global',
};
